import Store from '@owc-utils/Store/store';
import {
  headerComponentUpdate,
  addToHeaderTracking,
  addAndSubmitTracking,
  flyoutOpen,
  flyoutClose,
  modelsFlyoutChange,
  navigationLabelsUpdate,
} from '@owc-utils/Store/Header/actions';

import { HeaderState, NewChainNode } from '@owc-types/Header';
import { Unsubscribe } from 'redux';

let modelTopicId: string | null = null;
let openFlyoutId: string | null = null;

const setModelTopicId = (id: string) => {
  modelTopicId = id;
};

const getModelTopicId = () => modelTopicId;

const setOpenFlyoutId = (id: string | null) => {
  openFlyoutId = id;
};

const getOpenFlyoutId = () => openFlyoutId;

const isThisFlyoutOpen = (chain: string[], id: string) => {
  return chain?.includes(id);
};

const onHeaderStateChange = (listener: (state: HeaderState) => void): Unsubscribe => {
  return Store.subscribe(() => listener(Store.getState().header));
};

const removeOnHeaderStateChange = (unsubscribe: Unsubscribe) => {
  unsubscribe();
};

const setNavigationLabels = (menuAndFlyoutLabels: string) => {
  Store.dispatch({ type: navigationLabelsUpdate, payload: menuAndFlyoutLabels });
};

const setModelsFlyoutState = (state: boolean) => {
  Store.dispatch({ type: modelsFlyoutChange, payload: state });
};

const openHeaderFlyout = (infoToAdd: NewChainNode[]) => {
  Store.dispatch({ type: flyoutOpen, payload: infoToAdd });
};

const closeHeaderFlyout = (isClose: boolean, removeFromTracking = false) => {
  Store.dispatch({ type: flyoutClose, payload: { isClose, removeFromTracking } });
};

const addToTrackingTree = (infoToAdd: string, flyoutLevel: number) => {
  Store.dispatch({ type: addToHeaderTracking, payload: { infoToAdd, flyoutLevel } });
};

const addAndSubmitTrackingTree = (navigationLink: { label: string; url: string }, flyoutLevel: number) => {
  Store.dispatch({ type: addAndSubmitTracking, payload: { ...navigationLink, flyoutLevel } });
};

const setHeaderElement = (headerElement: Element) => {
  Store.dispatch({ type: headerComponentUpdate, payload: { headerElement } });
};

const getHeaderStoreState = () => Store.getState().header;

const mixin = {
  methods: {
    addToTrackingTree,
    addAndSubmitTrackingTree,
    openHeaderFlyout,
    closeHeaderFlyout,
    onHeaderStateChange,
    removeOnHeaderStateChange,
    isThisFlyoutOpen,
    setHeaderElement,
    setModelTopicId,
    getModelTopicId,
    setNavigationLabels,
    setOpenFlyoutId,
    getOpenFlyoutId,
    setModelsFlyoutState,
    getHeaderStoreState,
  },
};

export default mixin;
